import ContainerMainMenu from './components/container-main-menu'
import ContainerFiltersMenu from './components/container-filters-menu'
import MenuMain from '../menu-main/menu-main'
import Filters from '../filters/filters'


const ContainerMenu = ({ children }) => (
   <div id='outer-container'>

      <ContainerMainMenu>
         <MenuMain />
      </ContainerMainMenu>

      <ContainerFiltersMenu>
         <Filters />
      </ContainerFiltersMenu>

      {children}
   </div>
)

export default ContainerMenu
